// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-xs>
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-row wrap class="noprint">
            <v-col cols="12">
              <p class="headline font-weight-light">
                Use this page to generate printable QR codes.  Enter the tag value into the prompt below and select the QR code size.  Hide the menu during printing for best results.
              </p>
            </v-col>
          </v-row>
          <v-row wrap id="printablediv">
            <v-col cols="12">
              <p class="text-xs-center display-2">
              {{ tagString }}
              </p>
            </v-col>
            <v-col cols="12">
              <div class="text-xs-center">
                <canvas ref="qr"></canvas>
              </div>
            </v-col>
          </v-row>
          <v-row wrap class="noprint">
            <v-col cols="12" sm="6">
              <v-combobox
                v-model="tags"
                label="Tag"
                chips
                deletable-chips
              ></v-combobox>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
              v-model="size"
              label="Code Size"
              :items="sizes"
              chips
              >
              </v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import QRious from 'qrious'

export default {
  data () {
    return {
      code: null,
      categories: [],
      size: 300,
      sizes: [
        {
          text: 'Small',
          value: 100
        },
        {
          text: 'Medium',
          value: 300
        },
        {
          text: 'Large',
          value: 500
        },
        {
          text: 'X-Large',
          value: 700
        }
      ],
      tags: null
    }
  },

  mounted () {
    this.code = this.newCode(this.value)
  },

  computed: {
    tagString: function () {
      // return this.tags.join(',')
      return this.tags
    }
  },

  watch: {
    'size': function () {
      this.newCode()
    },

    'tags': function () {
      this.newCode()
    }
  },

  methods: {
    newCode: function () {
      return new QRious({
        element: this.$refs.qr,
        level: 'H',
        padding: 0,
        size: this.size,
        value: this.tagString
      })
    }
  }
}
</script>

<style scoped>
@media print {
  body * {
    visibility: hidden;
  }
  #printablediv, #printablediv * {
    visibility: visible;
  }
  #printablediv {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// QRCode.vue?57914c13